<template>
  <div>
    <page-heading-info
    title="Jefferson County Commissioners' Office"
    phone="(740) 283-8697"
    courthouse="true"
    floor="1st Floor"
    email="commissioners@jeffersoncountyoh.com"
    ></page-heading-info>

    <!-- commish section -->
    <div class="row mt-3">
      <div class="col">
        <div class="row">
          <div class="col-md-4 mt-3 image-flex image-max">
            <img src="static/departments/commissioners/timmons_commish.jpg" alt="Commissioner Timmons" class="image-border" />
          </div>
          <div class="col-md-6 mt-3">
            <h2 class="text-dark">Eric Timmons, (R)</h2>
            <hr class="title-rule" />
            <div class="com-list mt-3">
              <ul>
                <li>
                  <span>Raised in Steubenville, OH</span>
                </li>
                <li>
                  <span>Graduate of Steubenville High School</span>
                </li>
                <li>
                  <span>Holds a Bachelor's Degree in Business Administration from Ohio University</span>
                </li>
                <li>
                  <span>Business Development Officer at WesBanco Bank Inc.</span>
                </li>
                <li>
                  <span>He has two children, Theodora and Kenny, with his wife Katie</span>
                </li>
                <li>
                  <span>
                    Active in the Jefferson Kiwanis Youth Soccer League through Steubenville Kiwanis Club,
                    Jefferson County Chamber of Commerce, as well as other organizations within the county
                  </span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- commish section -->
    <div class="row mt-3">
      <div class="col">
        <div class="row">
          <div class="col-md-4 mt-3 image-flex image-max">
            <img src="static/departments/commissioners/kleineke_commish.jpg" alt="Commissioner Kleineke" class="image-border" />
          </div>
          <div class="col-md-6 mt-3">
            <h2 class="text-dark">Ronald “Jake” Kleineke, (R)</h2>
            <hr class="title-rule" />
            <div class="com-list mt-3">
              <ul>
                <li>
                  <span>Lifelong Jefferson County resident</span>
                </li>
                <li>
                  <span>Studied Welding Tech at Jefferson County JVS</span>
                </li>
                <li>
                  <span>Graduated from Mingo High School</span>
                </li>
                <li>
                  <span>Owner of Eastern Construction Services and Co-Owner of Hidden Acres Lodge & Winery</span>
                </li>
                <li>
                  <span>Lives in Richmond, OH with his wife Lisa and has 3 daughters and 4 grandchildren</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- commish section -->
    <div class="row mt-3">
      <div class="col">
        <div class="row">
          <div class="col-md-4 mt-3 image-flex image-max">
            <img src="static/departments/commissioners/morelli_commish.jpg" alt="Commissioner Morelli" class="image-border" />
          </div>
          <div class="col-md-6 mt-3">
            <h2 class="text-dark">Tony Morelli, (R)</h2>
            <hr class="title-rule" />
            <div class="com-list mt-3">
              <ul>
                <li>
                  <span>Graduated from Wintersville High School 1975</span>
                </li>
                <li>
                  <span>Worked at Morelli Bros. Block and Brick before working in Sales and Operations at Sal Chemical Co for 30 years</span>
                </li>
                <li>
                  <span>Married in 1992 to Colleen a successful Nurse Practitioner</span>
                </li>
                <li>
                  <span>Together currently manage and own commercial real estate around our community</span>
                </li>
                <li>
                  <span>Active for years in local civic groups including Big Brothers, Friendship Room, Jefferson Metropolitan Housing, 
                  Brooke Hancock Jefferson Metropolitan Housing Planning Commission.</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>

    <text-box-title title="Notice To Bidders" class="mt-5">
      <note-documents note-id="40" class="ml-3 mr-3"></note-documents>
    </text-box-title>


    <text-box-title class="mt-3" title="Commissioner's Meeting Minutes">
      <div class="col ml-3 mr-3">

        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="9"
        title="2026 Minutes">
          <note-documents note-id="65"></note-documents>
        </collapse-view>

        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="8"
        title="2025 Minutes">
          <note-documents note-id="55"></note-documents>
        </collapse-view>

        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="7"  
        title="2024 Minutes">
          <note-documents note-id="52"></note-documents>
        </collapse-view>

        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="6"  
        title="2023 Minutes">
          <note-documents note-id="45"></note-documents>
        </collapse-view>

        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="4"  
        title="2022 Minutes">
          <note-documents note-id="42"></note-documents>
        </collapse-view>
      

        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="5"  
        title="2021 Minutes">
          <note-documents note-id="36"></note-documents>
        </collapse-view>
        
        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="3"  
        title="2020 Minutes">
          <note-documents note-id="29"></note-documents>
        </collapse-view>

        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="1"  
        title="2019 Minutes">
          <note-documents note-id="15"></note-documents>
        </collapse-view>
        
        <collapse-view
        class="mt-3"
        group="faq"
        slot-id="2"  
        title="2018 Minutes">
          <note-documents note-id="13"></note-documents>
        </collapse-view>
      </div>
    </text-box-title>
	
	<text-box-title title="Document Downloads" class="mt-5">
	  <note-documents note-id="33" class="ml-3 mr-3"></note-documents>
	</text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import PhotoInfoCard from '@/components/display-utils/PhotoInfoCard'
import CollapseView from '@/components/display-utils/CollapseView.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
  components: {
    PageHeadingInfo,
    PhotoInfoCard,
    CollapseView,
    TextBoxTitle,
    LinkBox,
    NoteDocuments
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
  .com-list ul {   
    padding-left: 18px; 
    list-style-type: square;
  }

  .com-list ul li {
    margin-bottom: 12px;
  }

  .com-list li {
    color: #a3a4a4; 
  }

  .com-list li span {
    color: black; 
  }

  .title-rule {
    border-top: 2px solid #cdcecf;
  }

  .image-border {
    border: 4px solid #8db8d8; /*#37434d;*/
  }
</style>

